var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetiingsOpenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.60364 20C1.34807 20 1.09031 19.9285 0.859856 19.7788C0.228022 19.3676 0.0489025 18.5217 0.460659 17.8899L5.58632 10.0157L0.235667 2.13172C-0.187558 1.50807 -0.0253668 0.658892 0.598822 0.235667C1.22246 -0.187558 2.07164 -0.0253668 2.49542 0.598822L8.35558 9.23316C8.66412 9.68806 8.67013 10.2838 8.37032 10.7448L2.7488 19.3796C2.48722 19.7816 2.0498 20 1.60364 20Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2257 20C9.97014 20 9.71238 19.9285 9.48193 19.7788C8.85009 19.3676 8.67097 18.5217 9.08273 17.8899L14.2084 10.0157L8.85774 2.13172C8.43451 1.50807 8.5967 0.658892 9.22089 0.235667C9.84453 -0.187558 10.6937 -0.0253668 11.1169 0.598822L16.9771 9.2337C17.2856 9.6886 17.2917 10.2844 16.9918 10.7453L11.3709 19.3796C11.1093 19.7816 10.6719 20 10.2257 20Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetiingsOpenArrow);
export default __webpack_public_path__ + "static/media/setiingsOpenArrow.4e75efd3d5a8aae77686bceac05abb6b.svg";
export { ForwardRef as ReactComponent };